import { Action, createReducer, on } from '@ngrx/store';
import * as countriesActions from '../actions/countries.actions';
import { CountryModel } from 'app/models/country-api.model';

export interface State {
  countries: CountryModel[];
}

export const initialState: State = {
  countries: [],
};

export const featureReducer = createReducer(
  initialState,
  on(countriesActions.loadCountriesSuccess, (state: State, { items }) => ({
    ...state,
    countries: items,
  }))
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
